import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
export const PrivateRoute = () => {
    const auth = useAuth();
    return auth ? _jsx(Outlet, {}) : _jsx(Navigate, { to: "login" });
};
